import axios from "axios";

function storeOrRemove(key, value) {
  if (value === undefined || value === null) {
    localStorage.removeItem(key);
  } else {
    localStorage.setItem(key, value);
  }
}

export default {
  async Register(context, Form) {
    let response = await axios.post("/register", Form);
    localStorage.setItem("token", response.data.data.token);
    axios.defaults.headers.common[
      "Authorization"
    ] = `Bearer ${response.data.data.token}`;
    // commit("setUser", { user: response });
    return response;
  },
  async Login({ commit }, Form) {
    try {
      let response = await axios.post("/login", Form);
      const payload = response?.data?.data;
      if (response?.data?.status != true || !payload?.token) {
        return response;
      }
      const account = payload.company || payload.employee || {};
      localStorage.setItem("token", payload.token);
      axios.defaults.headers.common[
        "Authorization"
      ] = `Bearer ${payload.token}`;
      storeOrRemove("name", account.name);
      storeOrRemove("email", account.email);
      storeOrRemove("address", account.address);
      storeOrRemove("phone", account.phone);
      storeOrRemove("type", payload.type);
      commit("syncProfile");
      commit("setUser", { user: response });

      return response;
    } catch (error) {
      return error.response;
    }
  },

  async logout({ commit }, { localOnly = false } = {}) {
    const token = localStorage.getItem('token');
    // Clear immediately, so 401 handling cannot recursively issue logout.
    commit('logout');
    delete axios.defaults.headers.common.Authorization;
    if (localOnly || !token) return;
    try {
      await axios.post('/logout', null, { headers: { Authorization: 'Bearer ' + token }, timeout: 10000 });
    } catch (error) {
      if (error?.response?.status !== 401) sessionStorage.setItem('logout-unconfirmed', '1');
    }
  },
};
